<template>
  <div class="card log-object">
    <div class="card-content">
      <p class="title">
        {{ logObject.target }}
      </p>
      <router-link :to="generateLink">Go to test results</router-link>
      <br>
      <table class="table">
        <thead>
          <tr>
            <th v-for="(testRun, index) in logObject.test_runs" :key="index">
              <router-link :to="generateLinkForPlatform(testRun.platform_id)">
                {{ `${testRun.platform} ${testRun.platform_version}` }}
              </router-link>
            </th>
          </tr>
        </thead>
        <tbody>
        <tr>
          <td v-for="(testRun, index) in logObject.test_runs" :key="index">
            <div v-for="(mtr, index) in testRun.mtr" :key="index">
              <router-link :to="generateLinkForMtr(testRun.platform_id, mtr.mtr_id)">
                {{ mtr.mtr }}
              </router-link>
              (<a :href="mtr.url" target="_blank">logs</a>)
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "LogObject",
        props: {
            logObject: Object,
        },
        computed: {
          ...mapGetters('Platforms', [
            'platformByName',
          ]),
            generateLink() {
                return { name: 'TestRunIndex', query: {
                    target_ids: [this.logObject.target_id],
                    product_ids: [this.logObject.product_id],
                } };
            },
        },
      methods: {
          generateLinkForPlatform(platformId) {
            const link = this.generateLink;
            link.query.platform_ids = [platformId];
            return link;
          },
          platform(name, version) {
            return this.platformByName(name, version);
          },
        generateLinkForMtr(platformId, mtrId) {
          const link = this.generateLinkForPlatform(platformId);
          link.query.mtr_ids = [mtrId];
          return link;
        }
      }
    }
</script>

<style lang="scss" scoped>
  .log-object {
    margin-bottom: 1em;
  }
</style>